import React from 'react';

const ArticleHit = ({hit}) => {

  const {
    handle,
    image,
    title,
    blog
  } = hit;

  const article_url = `/blogs/${blog.handle}/${handle}`;

  return (
    <a href={article_url} className="hit">
      <div className="hit-image">
        <img src={image} alt={title} />
      </div>
      <div className="hit-details">
        <div className="hit-title">{title}</div>
      </div>
    </a>
  );
};

export default ArticleHit;
